<div class="conf">
  <main class="conf__main">

    <div class="conf__mode-cards">
      <button class="mode-card"
              [class.on]="modo() === 'cpf'"
              (click)="setModo('cpf')"
              type="button">
        <span class="mode-card__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>
        </span>
        <span class="mode-card__title">Por CPF</span>
        <span class="mode-card__desc">Buscar cupons de um paciente</span>
      </button>

      @if (isAdmin()) {
        <button class="mode-card"
                [class.on]="modo() === 'cupom'"
                (click)="setModo('cupom')"
                type="button">
          <span class="mode-card__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
              <path d="M21 12V7a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-1"/>
              <path d="M21 12h-7"/>
              <circle cx="17" cy="12" r="1.5"/>
            </svg>
          </span>
          <span class="mode-card__title">Por Cupom</span>
          <span class="mode-card__desc">Ver quem recebeu um cupom</span>
        </button>
      }

      <button class="mode-card"
              [class.on]="modo() === 'atendimento'"
              (click)="setModo('atendimento')"
              type="button">
        <span class="mode-card__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
            <path d="M9 11l3 3L22 4"/>
            <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
          </svg>
        </span>
        <span class="mode-card__title">Por Atendimento</span>
        <span class="mode-card__desc">Conferir regras do cupom aplicado</span>
      </button>
    </div>

    @if (modo() === 'cpf') {
      <app-cpf-mode
        [qInicial]="qInicial()"
        (qChange)="onCpfQChange($event)" />
    } @else if (modo() === 'atendimento') {

      <section class="search-card">
        <label class="search-label">Número do atendimento</label>
        <div class="atend-row">
          <input class="atend-input"
                 type="text"
                 inputmode="numeric"
                 placeholder="Ex: 1822456"
                 [(ngModel)]="atendimentoInput"
                 (keydown.enter)="buscarAtendimento()" />
          <button class="btn btn--primary"
                  [disabled]="loadingAtendimento()"
                  (click)="buscarAtendimento()">
            @if (loadingAtendimento()) { Buscando... } @else { Buscar }
          </button>
          @if (atendimentoInput) {
            <button class="btn btn--ghost" (click)="limparAtendimento()">Limpar</button>
          }
        </div>
        @if (erroAtendimento()) {
          <div class="search-erro">{{ erroAtendimento() }}</div>
        }
      </section>

      @if (feedbackAplicacao(); as fb) {
        <div class="aplicar-feedback"
             [class.aplicar-feedback--ok]="fb.tipo === 'ok'"
             [class.aplicar-feedback--erro]="fb.tipo === 'erro'">
          <span>{{ fb.texto }}</span>
          <button type="button" class="aplicar-feedback__close" (click)="feedbackAplicacao.set(null)" aria-label="Fechar">&times;</button>
        </div>
      }

      @if (atendimentoResultado(); as res) {
        @if (res.cupomAplicado; as cup) {

          <section class="conf__hero">
            <div class="conf__hero-eyebrow">
              {{ res.status === 'APLICADO' ? 'Conferencia de cupom aplicado' : 'Cupom que o paciente tem direito (nao aplicado)' }}
            </div>

            <div class="conf__ticket" [class.conf__ticket--alerta]="res.status === 'NAO_APLICADO'">
              <span class="conf__ticket-notch conf__ticket-notch--l"></span>
              <span class="conf__ticket-notch conf__ticket-notch--r"></span>
              <div class="conf__ticket-perf"></div>

              <div class="conf__ticket-top">
                <span>Atendimento {{ res.nrAtendimento }} · {{ cup.paciente.nome }}</span>
                <span class="conf__ticket-status">
                  <span class="conf__ticket-dot"></span>
                  {{ res.status === 'APLICADO' ? 'Aplicado' : 'Nao aplicado · Tem direito' }}
                </span>
              </div>

              <h1 class="conf__ticket-code">{{ cup.codCupom }}</h1>

              <div class="conf__ticket-bottom">
                <span>{{ cup.dsCupom }}</span>
                @if (res.status === 'APLICADO' && cup.vlDescontoAplicado != null) {
                  <span class="conf__ticket-disc">{{ fmtR(cup.vlDescontoAplicado) }} desc.</span>
                }
              </div>
            </div>

            @if (res.status === 'APLICADO') {
              <p class="conf__hero-meta">
                Aplicado em {{ cup.dtUso ? fmtDtUso(cup.dtUso) : '-' }}
                @if (cup.unidadeUso) {
                  na unidade <strong>{{ cup.unidadeUso.dsNome }}</strong>
                }
                · CPF {{ cup.paciente.cpfMascarado }}
              </p>
            } @else {
              <p class="conf__hero-meta">
                @if (cartaoPodeAplicar(res)) {
                  Cupom emitido para o paciente e ainda NAO aplicado neste atendimento. Ele passa nas regras: aplique logo abaixo.
                } @else {
                  Cupom emitido para o paciente, mas NAO aplicado neste atendimento. Veja abaixo qual regra falhou.
                }
                · CPF {{ cup.paciente.cpfMascarado }}
              </p>
            }
          </section>

          <ng-container *ngTemplateOutlet="aplicarTpl; context: { $implicit: res }" />

          <section class="rules-card">
            <div class="rules-card__head">
              <h2 class="rules-card__title">{{ res.status === 'APLICADO' ? 'Regras configuradas' : 'Checagem das regras' }}</h2>
              <p class="rules-card__sub">
                {{ res.status === 'APLICADO' ? 'O que precisa ser verdade para o cupom ser aplicavel' : 'Resultado da verificacao para este atendimento' }}
              </p>
            </div>

            <div class="rules-list">
              @for (r of res.regras; track r.tipo) {
                <div class="rule"
                     [class.rule--inativa]="res.status === 'APLICADO' && !r.ativa"
                     [class.rule--falha]="r.passou === false">
                  <span class="rule__icon" aria-hidden="true">
                    @if (r.passou === false) {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                    } @else if (res.status === 'APLICADO' && !r.ativa) {
                      <span class="rule__dot"></span>
                    } @else {
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                    }
                  </span>
                  <div class="rule__body">
                    <div class="rule__title">{{ r.titulo }}</div>
                    <div class="rule__desc">{{ res.status === 'NAO_APLICADO' ? (r.motivo || r.descricao) : r.descricao }}</div>
                  </div>
                </div>
              }
            </div>
          </section>

          @if (res.procedimentos.length > 0) {
            <section class="rules-card">
              <div class="rules-card__head">
                <h2 class="rules-card__title">Procedimentos do atendimento</h2>
                <p class="rules-card__sub">Os marcados como elegiveis contam para o cupom</p>
              </div>
              <div class="proc-table-wrap">
                <table class="proc-table">
                  <thead>
                    <tr>
                      <th>Codigo</th><th>Procedimento</th>
                      <th class="num">Qtd</th><th class="num">Valor</th>
                      <th class="center">Elegivel</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (p of res.procedimentos; track p.cdProcedimento) {
                      <tr [class.proc--eleg]="p.elegivel">
                        <td class="mono">{{ p.cdProcedimento }}</td>
                        <td>{{ p.dsProcedimento }}</td>
                        <td class="num">{{ p.qtProcedimento }}</td>
                        <td class="num">{{ fmtR(p.vlProcedimento) }}</td>
                        <td class="center">
                          <span class="proc-badge" [class.proc-badge--no]="!p.elegivel">
                            {{ p.elegivel ? 'Elegivel' : 'Nao conta' }}
                          </span>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </section>
          }

        } @else {
          <div class="state state--empty">
            Este paciente nao tem cupom emitido para o atendimento <b>{{ res.nrAtendimento }}</b>.
          </div>
          <ng-container *ngTemplateOutlet="aplicarTpl; context: { $implicit: res }" />
        }

      }

    } @else if (!cupomSelecionado()) {

      <section class="search-card">
        <label class="search-label">Código ou nome do cupom</label>
        <div class="combobox-wrap">
          <div class="combobox">
            <input class="combobox-input"
                   type="text"
                   placeholder="Digite codigo ou nome (4+ caracteres)..."
                   [ngModel]="searchTerm()"
                   (ngModelChange)="onSearchTermChange($event)"
                   (focus)="showDropdown.set(true)" />
            <svg class="combobox-caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>
          </div>

          @if (showDropdown()) {
            <div class="combobox-options">
              @if (loadingSuggest()) {
                <div class="combobox-empty">Buscando...</div>
              } @else if (searchTerm().length < 3) {
                <div class="combobox-empty">Digite ao menos 3 caracteres.</div>
              } @else if (suggestions().length === 0) {
                <div class="combobox-empty">Nenhum cupom bate com "{{ searchTerm() }}".</div>
              } @else {
                @for (s of suggestions(); track s.nrSequencia) {
                  <div class="combobox-option" (click)="selecionar(s)">
                    <div class="opt-code">{{ s.codCupom }}</div>
                    <div class="opt-name">{{ s.dsCupom }}</div>
                    <div class="opt-meta">
                      <span class="opt-badge">{{ tipoLabel(s.ieTipo) }}</span>
                      {{ fmtN(s.totalEmissoes) }} emissoes
                    </div>
                  </div>
                }
              }
            </div>
          }
        </div>

        @if (erroSelecao()) {
          <div class="search-erro">{{ erroSelecao() }}</div>
        }
      </section>

    } @else {

      <section class="conf__hero">
        <div class="conf__hero-eyebrow">Conferência de cupom</div>

        <div class="conf__ticket">
          <span class="conf__ticket-notch conf__ticket-notch--l"></span>
          <span class="conf__ticket-notch conf__ticket-notch--r"></span>
          <div class="conf__ticket-perf"></div>

          <div class="conf__ticket-top">
            <!-- Marca anterior: <span>SimCare · Cupom #{{ cupomSelecionado()!.nrSequencia }}</span> -->
            <span>Flua · Cupom #{{ cupomSelecionado()!.nrSequencia }}</span>
            <span class="conf__ticket-status">
              <span class="conf__ticket-dot"></span>
              Ativo
            </span>
          </div>

          <h1 class="conf__ticket-code">{{ cupomSelecionado()!.codCupom }}</h1>

          <div class="conf__ticket-bottom">
            <span>{{ cupomSelecionado()!.dsCupom }}</span>
            @if (descontoOff(cupomSelecionado()!); as off) {
              <span class="conf__ticket-disc">{{ off }}</span>
            }
          </div>
        </div>

        <p class="conf__hero-meta">
          Cupom <strong>{{ tipoLabel(cupomSelecionado()!.ieTipo).toLowerCase() }}</strong>
          com {{ descontoLabel(cupomSelecionado()!).toLowerCase() }}.
          @if (cupomSelecionado()!.dtVigenciaFim) {
            Vigencia ate {{ fmtDt(cupomSelecionado()!.dtVigenciaFim!) }}.
          } @else {
            Sem prazo final.
          }
        </p>

        <div class="conf__hero-actions">
          <button type="button" class="btn btn--ghost" (click)="trocarCupom()">Trocar cupom</button>
        </div>
      </section>

      @if (erroDados()) {
        <div class="alert">{{ erroDados() }}</div>
      }

      <section class="conf__metrics">
        <div class="metric metric--big">
          <div class="metric__label">Aplicações totais</div>
          <div class="metric__value-row">
            <div class="metric__value metric__value--xl">{{ fmtN(estatisticas()?.totalUsados ?? 0) }}</div>
          </div>
          <div class="metric__sub">
            de {{ fmtN(estatisticas()?.totalEmitidos ?? 0) }} cupons emitidos
          </div>
        </div>

        <div class="metric-grid">
          <div class="metric metric--small">
            <div class="metric__label">Descontado</div>
            <div class="metric__value">{{ fmtR(estatisticas()?.totalDescontado ?? 0) }}</div>
            <div class="metric__sub">total</div>
          </div>
          <div class="metric metric--small">
            <div class="metric__label">Ticket médio</div>
            <div class="metric__value">{{ fmtR(ticketMedio()) }}</div>
            <div class="metric__sub">por aplicação</div>
          </div>
          <div class="metric metric--small">
            <div class="metric__label">Pacientes</div>
            <div class="metric__value">{{ fmtN(estatisticas()?.totalPacientesUnicos ?? 0) }}</div>
            <div class="metric__sub">únicos</div>
          </div>
        </div>
      </section>

      <section class="chart-card">
        <div class="chart-head">
          <div>
            <h2 class="chart-title">Usos no periodo</h2>
            <p class="chart-sub">Aplicacoes por dia · {{ chartLegenda() }}</p>
          </div>
          <div class="chart-toggle">
            <button type="button" [class.on]="chartDias() === 7" (click)="setChartDias(7)">7d</button>
            <button type="button" [class.on]="chartDias() === 30" (click)="setChartDias(30)">30d</button>
            <button type="button" [class.on]="chartDias() === 90" (click)="setChartDias(90)">90d</button>
            <button type="button" [class.on]="chartDias() === ytdDias()" (click)="setChartDias(ytdDias())">YTD</button>
          </div>
        </div>

        @if (loadingChart()) {
          <div class="chart-empty">Carregando grafico...</div>
        } @else if (chartPontos().length === 0) {
          <div class="chart-empty">Nenhum uso no periodo selecionado.</div>
        } @else {
          <div class="chart-bars" [style.--total-bars]="chartPontos().length">
            @for (p of chartPontos(); track p.data; let last = $last) {
              <div class="chart-bar-wrap" [attr.title]="fmtBarTitle(p)">
                <div class="chart-bar" [class.chart-bar--last]="last" [style.height.%]="barAltura(p)"></div>
              </div>
            }
          </div>
          <div class="chart-axis">
            @if (chartPontos().length > 0) {
              <span>{{ fmtBarLabel(chartPontos()[0].data) }}</span>
              <span class="chart-axis__spacer"></span>
              <span>{{ fmtBarLabel(chartPontos()[chartPontos().length - 1].data) }}</span>
            }
          </div>
        }
      </section>

      @if (!historicoAberto() && ((estatisticas()?.porUnidade?.length ?? 0) > 0 || regrasCupom().length > 0)) {
        <div class="conf__split">
          @if ((estatisticas()?.porUnidade?.length ?? 0) > 0) {
            <section class="split-card">
              <div class="split-card__head">
                <h2 class="split-card__title">Por unidade</h2>
                <p class="split-card__sub">{{ estatisticas()!.porUnidade.length }} unidade(s) aplicaram este cupom</p>
              </div>
              <div class="unidades-list">
                @for (u of estatisticas()!.porUnidade; track u.cdEstabelecimento) {
                  <div class="unidade-row">
                    <div class="unidade-row__top">
                      <span class="unidade-row__name">{{ u.dsEstabelecimento }}</span>
                      <span class="unidade-row__val">
                        <b>{{ fmtN(u.totalUsos) }}</b> · {{ fmtR(u.totalDescontado) }}
                      </span>
                    </div>
                    <div class="unidade-row__bar">
                      <div class="unidade-row__bar-fill"
                           [style.width.%]="maiorUsoUnidade() > 0 ? (u.totalUsos / maiorUsoUnidade()) * 100 : 0">
                      </div>
                    </div>
                  </div>
                }
              </div>
            </section>
          }

          @if (regrasCupom().length > 0) {
            <section class="split-card">
              <div class="split-card__head">
                <h2 class="split-card__title">Regras configuradas</h2>
                <p class="split-card__sub">O que precisa ser verdade para o cupom ser aplicável</p>
              </div>
              <div class="rules-list">
                @for (r of regrasCupom(); track r.tipo) {
                  <div class="rule" [class.rule--inativa]="!r.ativa">
                    <span class="rule__icon" aria-hidden="true">
                      @if (r.ativa) {
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                      } @else {
                        <span class="rule__dot"></span>
                      }
                    </span>
                    <div class="rule__body">
                      <div class="rule__title">{{ r.titulo }}</div>
                      <div class="rule__desc">{{ r.descricao }}</div>
                    </div>
                  </div>
                }
              </div>
            </section>
          }
        </div>
      }

      @if (!historicoAberto()) {
        <section class="conf__block">
          <div class="conf__block-head">
            <h2 class="conf__block-title">Últimas aplicações</h2>
            <button type="button" class="conf__block-link" (click)="toggleHistorico()">
              Histórico completo →
            </button>
          </div>

          @if (aplicacoes().length === 0 && !loadingDados()) {
            <div class="state">Nenhuma aplicação encontrada para este cupom.</div>
          } @else {
            <div class="conf__table-wrap">
              <table class="conf__table">
                <thead>
                  <tr>
                    <th>Quando</th>
                    <th>Paciente</th>
                    <th>Unidade</th>
                    <th class="num">Valor</th>
                    <th>Operador</th>
                  </tr>
                </thead>
                <tbody>
                  @for (a of aplicacoes(); track a.nrSequencia) {
                    <tr>
                      <td class="muted">{{ fmtDtUso(a.dtUso) }}</td>
                      <td class="upper">{{ a.nmPaciente }}</td>
                      <td>{{ a.dsEstabelecimento }}</td>
                      <td class="num accent">{{ fmtR(a.vlDescontoAplicado) }}</td>
                      <td class="mono mini">{{ a.nmOperador }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </section>
      }

      @if (historicoAberto()) {
        <section class="historico-card">
          <div class="historico-card__head">
            <div>
              <h2 class="historico-card__title">Histórico completo</h2>
              <p class="historico-card__sub">Aplicações no período selecionado</p>
            </div>
            <button type="button" class="conf__block-link" (click)="toggleHistorico()">
              ← Voltar para últimas aplicações
            </button>
          </div>

          <div class="historico-filters">
            <label class="historico-field">
              <span>De</span>
              <input type="date" [(ngModel)]="historicoDataIni" />
            </label>
            <label class="historico-field">
              <span>Até</span>
              <input type="date" [(ngModel)]="historicoDataFim" />
            </label>
            <label class="historico-field historico-field--unidade">
              <span>Unidade</span>
              <select [ngModel]="historicoCdEstab()" (ngModelChange)="historicoCdEstab.set($event === '' || $event === null ? null : +$event)">
                <option [ngValue]="null">Todas as unidades</option>
                @for (u of estatisticas()?.porUnidade ?? []; track u.cdEstabelecimento) {
                  <option [ngValue]="u.cdEstabelecimento">{{ u.dsEstabelecimento }} ({{ u.totalUsos }})</option>
                }
              </select>
            </label>
            <button type="button" class="btn btn--primary" (click)="historicoPagina.set(1); aplicarHistorico()" [disabled]="historicoLoading()">
              @if (historicoLoading()) { Aplicando... } @else { Aplicar }
            </button>
          </div>

          @if (historicoErro()) {
            <div class="search-erro">{{ historicoErro() }}</div>
          }

          @if (!historicoLoading()) {
            @if (historicoItens().length === 0) {
              <div class="state">Sem aplicações nesse período.</div>
            } @else {
              <div class="conf__table-wrap">
                <table class="conf__table">
                  <thead>
                    <tr>
                      <th>Quando</th>
                      <th>Paciente</th>
                      <th>Unidade</th>
                      <th class="num">Valor</th>
                      <th>Operador</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (a of historicoItens(); track a.nrSeqCupomPaciente) {
                      <tr>
                        <td class="muted">{{ a.dtUso ? fmtDtUso(a.dtUso) : '-' }}</td>
                        <td class="upper">{{ a.paciente.nome }}</td>
                        <td>{{ a.unidadeUso?.dsNome || '-' }}</td>
                        <td class="num accent">{{ a.vlDescontoAplicado != null ? fmtR(a.vlDescontoAplicado) : '-' }}</td>
                        <td class="mono mini">{{ a.nmOperador || '-' }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
              <div class="historico-pager">
                <span>
                  Mostrando {{ (historicoPagina() - 1) * historicoTake + 1 }}–{{ Math.min(historicoPagina() * historicoTake, historicoTotal()) }} de {{ historicoTotal() }}
                </span>
                <div class="pager-buttons">
                  <button (click)="mudarPaginaHistorico(historicoPagina() - 1)" [disabled]="historicoPagina() === 1">‹</button>
                  <span class="pager-info">Página {{ historicoPagina() }} de {{ historicoTotalPaginas() }}</span>
                  <button (click)="mudarPaginaHistorico(historicoPagina() + 1)" [disabled]="historicoPagina() >= historicoTotalPaginas()">›</button>
                </div>
              </div>
            }
          }
        </section>
      }

    }

  </main>
</div>

<!-- Aplicar cupom: logo abaixo do cartao (NAO_APLICADO) ou do aviso de sem cupom -->
<ng-template #aplicarTpl let-res>
  @if (res.status === 'NAO_APLICADO' || res.status === 'SEM_CUPOM') {
    <section class="rules-card">
      <div class="rules-card__head">
        <h2 class="rules-card__title">Aplicar cupom no atendimento</h2>
        <p class="rules-card__sub">
          @if (res.conta?.aplicavel) {
            Conta {{ res.conta?.codigo || res.conta?.nrInternoConta }} apta a receber o cupom.
          } @else {
            {{ res.conta?.motivo || 'Conta nao aplicavel.' }}
          }
        </p>
      </div>

      @if (!res.cuponsDisponiveis?.length) {
        <div class="state state--empty">Nenhum cupom disponivel na carteira do paciente.</div>
      } @else {
        <div class="aplicar-list">
          @for (c of (res.cuponsDisponiveis ?? []); track c.nrSeqCupomPaciente) {
            <div class="aplicar-item" [class.aplicar-item--bloqueado]="!c.podeAplicar">
              <div class="aplicar-item__info">
                <div class="rule__title">{{ c.codCupom }}</div>
                <div class="rule__desc">{{ c.dsCupom }}</div>
                <div class="rule__desc">
                  @if (c.ieTipoDesconto === 'P' && c.prDesconto != null) { Desconto {{ c.prDesconto }}% }
                  @else if (c.vlDesconto != null) { Desconto {{ fmtR(c.vlDesconto) }} }
                  @if (c.dtExpiracao) { · Valido ate {{ fmtDt(c.dtExpiracao) }} }
                </div>
                @if (c.descontoEstimado) {
                  <div class="rule__desc">{{ c.descontoEstimado }} <span class="proc-badge">estimado</span></div>
                }
                @if (!c.podeAplicar && c.motivoBloqueio) {
                  <div class="search-erro">{{ c.motivoBloqueio }}</div>
                }
              </div>
              <div class="aplicar-item__actions">
                @if (confirmarAplicarId() === c.nrSeqCupomPaciente) {
                  <span class="aplicar-item__q">Aplicar {{ c.codCupom }} no atendimento {{ res.nrAtendimento }}, conta {{ res.conta?.nrInternoConta }}?</span>
                  <button class="btn btn--primary" (click)="confirmarAplicar(res, c)" [disabled]="aplicandoId() !== null">{{ aplicandoId() === c.nrSeqCupomPaciente ? 'Aplicando...' : 'Confirmar' }}</button>
                  <button class="btn btn--ghost" (click)="cancelarAplicar()" [disabled]="aplicandoId() !== null">Cancelar</button>
                } @else {
                  <button class="btn btn--primary" (click)="pedirAplicar(c)" [disabled]="!c.podeAplicar || aplicandoId() !== null">Aplicar</button>
                }
              </div>
            </div>
          }
        </div>
      }
    </section>
  }
</ng-template>
